module.exports = __webpack_public_path__ + "zvetseni-prsou_50_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_50_after.jpg
// module id = 1345
// module chunks = 0